export default "__VITE_ASSET__DmgbYUb8__"